import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export function isNeedToShowClearButton({
  ButtonClear,
  blocked,
  disabled,
  handleClear,
  multi,
  searchValue,
  value,
}) {
  const hasSearchValue = searchValue && searchValue !== FORMIK_EMPTY_VALUE
  const hasValue = !multi && value && value !== FORMIK_EMPTY_VALUE

  return (
    ButtonClear &&
    !disabled &&
    !blocked &&
    handleClear &&
    (hasSearchValue || hasValue)
  )
}
